import React, { Component } from 'react';

import Header from './Header';
import SectionHeader from './SectionHeader';
import CapabilityRow from './CapabilityRow';
import Legend from './Legend';
import '../../styles/main.less';
import { ApiVersion } from '../../data/versions';
import PropTypes from 'prop-types';

export default class ChannelCapabilitiesGrid extends Component {
    constructor(props) {
        super(props);
        this.someRefName = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    static propTypes = {
        capability: PropTypes.string.isRequired,
        capabilities: PropTypes.object.isRequired,
        channels: PropTypes.array.isRequired,
        isLastRow: PropTypes.bool.isRequired,
        className: PropTypes.string.isRequired,
        version: PropTypes.string.isRequired,
    };

    state = {};

    generateRows(capabilities) {
        return capabilities.map((c, i) => {
            /**
             * The last row should not have bottom border since
             * the top border from the section header has a border already
             */
            const isLastRow = capabilities.length - 1 === i;
            return (
                <CapabilityRow
                    key={c}
                    capability={c}
                    channels={this.props.channels}
                    capabilities={this.props.capabilities}
                    isLastRow={isLastRow}
                />
            );
        });
    }

    handleScroll = () => {
        const { top } = this.someRefName.current.getBoundingClientRect();

        /**
         * To avoid adding every position to state
         * only check when going from positive <-> negative position and set state
         */
        if (!this.state.top || Math.sign(this.state.top) !== Math.sign(top)) {
            this.setState({
                top,
                isSticky: top < 0,
            });
        }
    };

    render() {
        const { isSticky } = this.state;
        const { version } = this.props;

        return (
            <div className="channel-capabilities-grid">
                {version === ApiVersion.v2 ? <h1>Channel Capabilities</h1> : <h1>Channel Capabilities v1</h1>}
                <p className="intro">
                    The Sunshine Conversations API gives you access to the richest features across the broadest set of
                    messaging channels. This comparison grid provides a comprehensive view of feature support across all
                    available channel. Notice that support level may vary based on channel as well as direction of the
                    message (send or receive). For any questions regarding our feature support, feel free to get in
                    touch with us to discuss your use case.
                </p>
                <div ref={this.someRefName}></div>
                <Header channels={this.props.channels} isSticky={isSticky} />
                <Legend />
                <SectionHeader channelCount={this.props.channels.length}>Content types</SectionHeader>
                {this.generateRows(['text', 'image', 'file', 'emoji', 'gif', 'location'])}
                <SectionHeader channelCount={this.props.channels.length}>Action types</SectionHeader>
                {this.generateRows(['link', 'webview', 'buy', 'postback', 'replies', 'locationRequest'])}
                <SectionHeader channelCount={this.props.channels.length}>Structured messages</SectionHeader>
                {this.generateRows(['compoundMessages', 'carousel', 'form', 'list'])}
                <SectionHeader channelCount={this.props.channels.length}>Indicators</SectionHeader>
                {this.generateRows(['typingIndicator', 'readIndicator', 'conversationStart'])}
                <SectionHeader channelCount={this.props.channels.length}>Delivery Events</SectionHeader>
                {this.generateRows(['channelDeliveryEvents', 'userDeliveryEvents'])}
                <SectionHeader channelCount={this.props.channels.length}>Account linking</SectionHeader>
                {this.generateRows(
                    version !== ApiVersion.v2
                        ? ['webMessengerLinking']
                        : ['webMessengerLinking', 'APILinking', 'linkingRequests']
                )}
                <SectionHeader channelCount={this.props.channels.length}>Notification Capabilities</SectionHeader>
                {this.generateRows(['pushCapable'])}

                {version !== ApiVersion.v2 && (
                    <SectionHeader channelCount={this.props.channels.length}>Outbound Messaging</SectionHeader>
                )}
                {version !== ApiVersion.v2 && this.generateRows(['notificationEvents'])}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/index.js